/* eslint-disable no-inner-declarations */
import ScreenLock from '../__constants/lock-screen';

const $ = jQuery.noConflict();

class Popup {
	constructor(popupOpen, popup, popupClose, heroBottomWrap) {
		this.popupOpen = popupOpen;
		this.popup = popup;
		this.popupClose = popupClose;
		this.heroBottomWrap = heroBottomWrap;
	}
	openPopup(e) {
		let popup;
		let popupId;
		if (e.currentTarget.getAttribute('data-popupid')) {
			popupId = e.currentTarget.getAttribute('data-popupid');
			popup = document.querySelector(`[data-popup="${popupId}"]`);
		} else {
			const buttonWrapper = e.currentTarget.parentNode;
			popup = buttonWrapper.querySelector(this.popup);
		}
		let heroBottomWrap = null;
		if (this.heroBottomWrap) {
			heroBottomWrap = document.querySelector(this.heroBottomWrap);
		}
		if (!popup.classList.contains('is-active')) {
			popup.classList.add('is-active');
			if (heroBottomWrap) {
				heroBottomWrap.classList.add('is-active');
			}
			if (popupId) {
				$('.popup-slider__nav').slick('setPosition');
				$('.popup-slider__main').slick('setPosition');
			}
			setTimeout(function() {
				$('.popup-gallery__main').slick('setPosition');
				$('.popup-gallery__nav').slick('setPosition');
			}, 0 );
			ScreenLock.lock();
		}
	}
	closePopup(e) {
		const popup = e.currentTarget.parentNode.parentNode;
		let heroBottomWrap = null;
		if (this.heroBottomWrap) {
			heroBottomWrap = document.querySelector(this.heroBottomWrap);
		}
		if (popup.classList.contains('is-active')) {
			popup.classList.remove('is-active');
			if (heroBottomWrap) {
				heroBottomWrap.classList.remove('is-active');
			}
			ScreenLock.unlock();
		}
	}
	openPopupWithDelay(element) {
		const startTime = new Date().getTime() / 1000;
		if (this.heroBottomWrap !== '') {
			const heroBottomWrap = document.querySelector(this.heroBottomWrap);
			function openWithDelay() {
				const now = new Date().getTime() / 1000;
				const delay = now - startTime;
				if (delay < 30) {
					requestAnimationFrame(openWithDelay);
				} else {
					element.classList.add('is-active');
					heroBottomWrap.classList.add('is-active');
					ScreenLock.lock();
				}
			}
			requestAnimationFrame(openWithDelay);
		}
	}
	init() {
		let popupBtns = document.querySelectorAll(this.popupOpen);
		let popupCloseBtns = document.querySelectorAll(this.popupClose);
		let popup = document.querySelectorAll(this.popup);
		if (popupBtns) {
			popupBtns = Array.prototype.slice.call(popupBtns);
			popupBtns.forEach((popupBtn) => {
				popupBtn.addEventListener('click', (e) => {
					this.openPopup(e);
				});
			});
		}
		if (popupCloseBtns) {
			popupCloseBtns = Array.prototype.slice.call(popupCloseBtns);
			popupCloseBtns.forEach((popupCloseBtn) => {
				popupCloseBtn.addEventListener('click', (e) => {
					this.closePopup(e);
				});
			});
		}
		if (popup) {
			popup = Array.prototype.slice.call(popup);
			popup.forEach((element) => {
				if (element.classList.contains('open-with-delay')) {
					this.openPopupWithDelay(element);
				}
			});
		}
	}
}

const popup = new Popup('.popup-button', '.popup-overlay', '.popup-close', '.hero-bottom-wrap');
const popupProduct = new Popup('.prod-info-wrap .popup-button', '.popup-overlay', '.popup-close', '');
export default popup;
export { popupProduct };
